module.exports = __webpack_public_path__ + "media/images/area/feature/chugoku/04-8c890db884c4c9229c90758cbb11a14b.jpg";